// extracted by mini-css-extract-plugin
export default {"button":"ButtonBase_button__HiU-q","button-primary":"ButtonBase_button-primary__y5VGp","button-active":"ButtonBase_button-active__j2vVw"};